import _ from 'lodash';

import { FeeCureType } from 'constants/feeTypes';
import { LESection } from 'constants/loanApplication';
import { naturalSortBy } from 'utils/sort';

export const hasItemsWithPendingChanges = items =>
  items?.some(item => !!item.modifiedFields?.length);

const BASE_CURE_TABLE_COLUMNS_COUNT = 4;

export const getCureTableColumnsCount = ({
  isInitialLeColumnShown = false,
  hasPendingChanges = false,
}) =>
  BASE_CURE_TABLE_COLUMNS_COUNT + (isInitialLeColumnShown ? 1 : 0) + (hasPendingChanges ? 1 : 0);

export const getCureItemsByCureType = cureItems => {
  const itemsGroupedByCureType = _.groupBy(cureItems, 'cureType');
  const zeroItemsGroupedByLeSection = _.groupBy(
    itemsGroupedByCureType[FeeCureType.ZERO_TOLERANCE],
    'leSection',
  );
  const nonTransferTaxesZeroItems = _.flatMap(
    _.omit(zeroItemsGroupedByLeSection, LESection.TRANSFER_TAXES),
  );

  return {
    zeroCureItems: naturalSortBy(nonTransferTaxesZeroItems, 'name'),
    tenPercentCureItems: naturalSortBy(
      itemsGroupedByCureType[FeeCureType.TEN_PERCENT_TOLERANCE],
      'name',
    ),
    transferTaxCureItems: naturalSortBy(
      zeroItemsGroupedByLeSection[LESection.TRANSFER_TAXES],
      'name',
    ),
  };
};
